import { render, staticRenderFns } from "./InfiniteScrollObserver.vue?vue&type=template&id=51d7a8f1"
import script from "./InfiniteScrollObserver.vue?vue&type=script&lang=js"
export * from "./InfiniteScrollObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports